export const buildProtectedUploadUrl = (
  rawUrl,
  { mode = "view", filename } = {},
) => {
  if (!rawUrl || typeof rawUrl !== "string") return rawUrl;

  try {
    const sourceUrl = new URL(rawUrl, window.location.origin);
    const uploadsIndex = sourceUrl.pathname.indexOf("/uploads/");

    if (uploadsIndex === -1) {
      return rawUrl;
    }

    const relativeUploadPath = sourceUrl.pathname.slice(uploadsIndex + 1);
    const securedUrl = new URL("/api/upload-files/access", sourceUrl.origin);

    securedUrl.searchParams.set("path", relativeUploadPath);
    securedUrl.searchParams.set("mode", mode);

    if (filename) {
      securedUrl.searchParams.set("filename", filename);
    }

    return securedUrl.toString();
  } catch {
    return rawUrl;
  }
};
